function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M17 20.75H7C5.26991 20.75 3.97362 20.254 3.1098 19.3902C2.24598 18.5264 1.75 17.2301 1.75 15.5V8.5C1.75 6.76991 2.24598 5.47362 3.1098 4.6098C3.97362 3.74598 5.26991 3.25 7 3.25H17C18.7301 3.25 20.0264 3.74598 20.8902 4.6098C21.754 5.47362 22.25 6.76991 22.25 8.5V15.5C22.25 17.2301 21.754 18.5264 20.8902 19.3902C20.0264 20.254 18.7301 20.75 17 20.75ZM7 3.75C5.49651 3.75 4.28256 4.11533 3.44895 4.94895C2.61533 5.78256 2.25 6.99651 2.25 8.5V15.5C2.25 17.0035 2.61533 18.2174 3.44895 19.0511C4.28256 19.8847 5.49651 20.25 7 20.25H17C18.5035 20.25 19.7174 19.8847 20.5511 19.0511C21.3847 18.2174 21.75 17.0035 21.75 15.5V8.5C21.75 6.99651 21.3847 5.78256 20.5511 4.94895C19.7174 4.11533 18.5035 3.75 17 3.75H7Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 15.25C10.2061 15.25 8.75 13.7939 8.75 12C8.75 10.2061 10.2061 8.75 12 8.75C13.7939 8.75 15.25 10.2061 15.25 12C15.25 13.7939 13.7939 15.25 12 15.25ZM12 9.25C10.4839 9.25 9.25 10.4839 9.25 12C9.25 13.5161 10.4839 14.75 12 14.75C13.5161 14.75 14.75 13.5161 14.75 12C14.75 10.4839 13.5161 9.25 12 9.25Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.5 14.75C5.36614 14.75 5.25 14.6339 5.25 14.5V9.5C5.25 9.36614 5.36614 9.25 5.5 9.25C5.63386 9.25 5.75 9.36614 5.75 9.5V14.5C5.75 14.6339 5.63386 14.75 5.5 14.75Z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M18.5 14.75C18.3661 14.75 18.25 14.6339 18.25 14.5V9.5C18.25 9.36614 18.3661 9.25 18.5 9.25C18.6339 9.25 18.75 9.36614 18.75 9.5V14.5C18.75 14.6339 18.6339 14.75 18.5 14.75Z"
});

function SvgTransactions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactions);
export default __webpack_public_path__ + "static/media/transactions.48765251.svg";
export { ForwardRef as ReactComponent };